module.exports = __webpack_public_path__ + "assets/5421350c9deadda66bad58b47d13c3b2.png";